<div class="flex items-center gap-1.5">
  <a href="https://www.concurrencyglobal.com" target="_blank"
    class="hover:text-slate-900 dark:hover:text-slate-100 transition-colors font-medium">
    Concurrency Global Solutions 2026 &copy;
  </a>
</div>
<div class="flex gap-4">
  <a href="#" class="hover:text-slate-900 dark:hover:text-slate-100 transition-colors">Privacy Policy</a>
  <a href="#" class="hover:text-slate-900 dark:hover:text-slate-100 transition-colors">Terms of Service</a>
</div>